<template>
  <div>
    <div class="columns">
      <div class="column is-four-fifth" v-if="allPapers.length > 0">
        <div class="wrapper">
            <h1 class="title is-1 main-title" color="primary" >Overview</h1>
            <h2 class="title is-3" color="primary">Region Overview</h2>
            <pie-chart :data="getChartData(allPapers, regionOptions, 'Region')" :options="chartOptions" width='650px' height='350px'></pie-chart>
            <br>
            <h2 class="title is-3" color="primary">Category Overview</h2>
            <pie-chart :data="getChartData(allPapers, categoryOptions, 'Category')" :options="chartOptions" width='650px' height='350px'></pie-chart>
            <br>
            <h2 class="title is-3" color="primary">Topic Overview</h2>
            <pie-chart :data="getChartData(allPapers, topicOptions, 'Topic')" :options="chartOptions" width='650px' height='350px'></pie-chart>
            <br>
            <h2 class="title is-3" color="primary">Year Overview</h2>
            <pie-chart :data="getYearData(allPapers)" :options="chartOptions" width='650px' height='350px'></pie-chart>
            <br>
            <h2 class="title is-3" color="primary">Language Overview</h2>
            <pie-chart :data="getChartData(allPapers, languageOptions, 'Language')" :options="chartOptions" width='650px' height='350px'></pie-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from '@/components/PieChart.js'
import { PAPER_SEARCH_QUERY } from '@/graphql'
import { topicOptions, categoryOptions, languageOptions, regionOptions, colorsOptions } from '@/options'

export default {
  name: 'Papers',
  components: {
    PieChart
  },
  data () {
    return {
      allPapers: [],

      // Drop down options
      categoryOptions: categoryOptions,
      languageOptions: languageOptions,
      regionOptions: regionOptions,
      topicOptions: topicOptions,
      colorsOptions: colorsOptions,

      // chart options
      chartOptions: {
        hoverBorderWidth: 10,
        hoverBackgroundColor: 'red',
        title: {
          display: true,
          text: 'Chart.js Doughnut Chart'
        },
        legend: {
          position: 'top'
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    }
  },
  apollo: {
    // fetch all papers
    allPapers: {
      query: PAPER_SEARCH_QUERY,
      variables () {
        return {
          title: '',
          category: [],
          topic: [],
          year: parseInt(''),
          region: [],
          language: []
        }
      },
      error (errorDetails) {
        if (errorDetails.message.includes('Authentication Failure') || errorDetails.message.includes('Signature has expired')) {
          localStorage.removeItem('app-token')
        }
      }
    }
  },
  methods: {
    getYearData: function (paper) {
      let years = {}
      paper.forEach(element => {
        if (element.year <= 2000) {
          // 2000 and before this
          years['Before 2000'] = (years['Before 2000'] || 0) + 1
        } else {
          // dividing in groups as per range
          let lowerRange = (Math.floor((element.year - 2000) / 5) * 5) + 2001
          let upperRange = lowerRange + 5 > new Date().getFullYear() ? new Date().getFullYear() : lowerRange + 4
          years[`${lowerRange}-${upperRange}`] = (years[`${lowerRange}-${upperRange}`] || 0) + 1
        }
      })
      let result = Object.keys(years).map((key) => key)
      let dataresult = Object.keys(years).map((key) => years[key])
      let colors = colorsOptions.slice(0, result.length)
      return {
        hoverBackgroundColor: 'red',
        hoverBorderWidth: 10,
        labels: result,
        datasets: [
          {
            label: `Overview per Year`,
            backgroundColor: colors,
            data: dataresult
          }
        ]
      }
    },
    getChartData: function (paper, chartData, type) {
      let result = Object.keys(chartData).map((key) => chartData[key])
      let resultNums = Object.keys(chartData).map((key) => key)
      let colors = colorsOptions.slice(0, result.length)
      let dataresult = resultNums.map(e => {
        let count = 0
        this.allPapers.filter(p => {
          switch (type) {
            case 'Region':
              if (p.region === e) {
                count++
              }
              break
            case 'Category':
              if (p.category === e) {
                count++
              }
              break
            case 'Topic':
              if (p.mainTopics.includes(e)) {
                count++
              }
              break
            case 'Language':
              if (p.language === e) {
                count++
              }
              break
            default:
              break
          }
        })
        return count
      })
      return {
        hoverBackgroundColor: 'red',
        hoverBorderWidth: 10,
        labels: result,
        datasets: [
          {
            label: `Overview per ${type}`,
            backgroundColor: colors,
            data: dataresult
          }
        ]
      }
    }
  }
}
</script>
<style scoped>
.wrapper{
  margin: 2rem;
}
.main-title{
  margin-bottom: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Papers/Overview.vue